import React, { useState, useEffect } from 'react';
 
import useTable from '../useTable'
import axios from 'axios';

import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';
import moment from 'moment';
import AgregarUnidadContable from './modalActualizarUnContable';
/* import { ToastsGeneral } from '../toasts'; */
import { Toasts } from '../toasts';
import {
    formatMoneda
} from '../../util/varios';
import AgregarUnidadTribubtaria from './modalActualizarUnTributaria';

const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'AÑO', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'VALOR', textAlign: 'center' },
    { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' }

]

function UnidadTributaria() {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const permiso = JSON.parse(localStorage.getItem('accut'))

    const [mostrar5, setMostrar5] = useState(false);
    const [idUsuarioH, setIdUsuarioH] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [tipo, setTipo] = useState()
    const [operacion, setOperacion] = useState(0);
    const [usuarioH, setUsuarioH] = useState();
    const [persona, setPersona] = useState();

    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();


    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));


    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [records, setRecords] = useState([]);
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [values, setValues] = useState()
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    /*   const accusertim = JSON.parse(localStorage.getItem('accusertim')); */

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);


    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.anio.toString().includes(target.value)
                            || moment.utc(x.fecha).format('YYYY-MM-DD').includes(target.value)
                            || formatMoneda(x.valor.replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value)

                        ) {
                            return x;
                        }
                    });
                }
            }
        })

    }


    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        setIdUsuario(obj.idusuario);
        setEspiritu(obj.espiritu);
        seleccionarUnidadTributaria();
    }, []);

    const seleccionarUnidadTributaria = () => {
        setActivate(true);



        let campos = '*';
        let nomtab = 'unidadtributaria';
        let orden = 'anio';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        console.log(endpoint)

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {
                    console.log(response.data)
                    setRecords(response.data);
                    setActivate(false);
                } else {
                    setRecords([]);
                }
            }

            setActivate(false);

        }).catch((error) => {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        })
    };





    const gestionarUnidad = (item, op, per) => (e) => {
        console.log(item)
        e.preventDefault()

        if (per.toString() === '1') {
            setOperacion(op)
            if (op !== 1) {
                setValues(item)
                setMostrar(true)


            } else {
                setMostrar(true)

            }

        } else {
            setToast({
                mostrar: true,
                mensaje: op === 1 ? 'No posee permiso para Registrar' : op === 2 ? 'No posee permiso para Editar' : op === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
                titulo: 'Alerta.'
            })
        }



    }

    const cerrarToast = () => {
        setToast({
            mostrar: false
        })
    }

    const cerrarModalActualizar = () => {

        setUsuarioH();
        setUsuariow();
        setPersona();
        setMostrar(false);
        setActivate(false)

    }

    const validarActuUsuario = () => {

        if (operacion === 4) {
            setUsuarioH();
            setMostrar(false);
            return;
        }
        if (operacion === 1) {
            setIdUsuarioH(0);
        }
        setUsuarioH();
        setUsuariow();
        setPersona();
        setMostrar(false);

    }


    const cambiarClave = () => {
        setMostrar2(true);
    };

    const handleCloseClave = () => {
        setMostrar2(false);
    }

    return (
        <div className="h-100 w-100 p-0 m-0">


            <div className="container">
                <div className="content">
                    <div className="card col-md-7 mx-auto px-3 py-2">
                        <div className="col-md-12 row m-0 py-1">

                            <div className="col-md-5">
                                <input type="text" className="form-control search-input form-control-sm rounded-pill" onChange={handleSearch} placeholder="Buscar" />
                            </div>

                            <div className="col-md-6 ">

                            </div>
                            <div className="col-md-1 ml-auto">
                                <button onClick={gestionarUnidad('', 1,permiso.toString().substring(0, 1))} style={{ marginBottom: "5px" }} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-primary rounded-pill' : 'btn btn-sm btn-secondary rounded-pill'}><i className="fas fa-plus"></i> </button>
                            </div>

                        </div>
                        <div className="col-md-12" style={{ margin: "auto" }} >
                            <TblContainer >
                                <TblHead />

                                <tbody>
                                    {

                                        records && recordsAfterPagingAndSorting().map((item, index) => (
                                            <tr key={index} style={{ padding: "0" }}>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "50px" }}>{item.anio}</td>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{moment.utc(item.fecha).format('DD-MM-YYYY')}</td>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{formatMoneda(item.valor.toString().replace('.', ','), ',', '.', 2)}</td>
                                                <td className='align-baseline' style={{ textAlign: "center", width: '200px' }}>
                                                    <button onClick={gestionarUnidad(item, 4,permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'} ><i className="fas fa-eye"></i> </button>
                                                    <button onClick={gestionarUnidad(item, 2,permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-edit"></i> </button>
                                                    <button onClick={gestionarUnidad(item, 3,permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-trash"></i> </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>

                            </TblContainer>
                            <TblPagination />

                        </div>
                    </div>
                </div>
            </div>

            <AgregarUnidadTribubtaria
                show={mostrar}
                onHideCancela={() => { setMostrar(false), setValues('') }}
                operacion={operacion}
                unidad={values}
                renderizar={seleccionarUnidadTributaria}
            />

            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />
        </div >

    );

}

export default UnidadTributaria;